import { useState } from 'react';
import { Switch } from "@components/ui/switch";
import { Label } from "@components/ui/label";
import { cn } from "@lib/utils";

const Toggle = (
  {
    label,
    isDefaultChecked,
    toggleActionCallback,
    checkedBg,
    uncheckedBg,
    disabled,
  }
  :
  {
    label: string,
    isDefaultChecked?: boolean,
    toggleActionCallback: (isChecked: boolean) => void,
    checkedBg?: string,
    uncheckedBg?: string,
    disabled?: boolean,
  }
) => {

  const [isChecked, setIsChecked] = useState(isDefaultChecked || false);

  const handleToggle = (checked: boolean) => {
    if (disabled) return;
    toggleActionCallback(checked);
    setIsChecked(checked);
  };

  const activeBg = checkedBg ?? 'bg-cSecondaryGreen';
  const inactiveBg = uncheckedBg ?? 'bg-cGreen';

  return (
    <div className={cn("flex items-center", disabled && "opacity-50")}>
      <Label
        htmlFor="toggle"
        className={cn("mr-3", disabled ? "cursor-not-allowed" : "cursor-pointer")}
      >
        {label}
      </Label>
      <Switch
        id="toggle"
        checked={isChecked}
        onCheckedChange={handleToggle}
        disabled={disabled}
        className={cn(
          isChecked ? activeBg : inactiveBg,
          "h-6 w-12 data-[state=checked]:bg-none data-[state=unchecked]:bg-none",
          "[&>span]:h-5 [&>span]:w-5 [&>span]:data-[state=checked]:translate-x-6 [&>span]:data-[state=unchecked]:translate-x-0",
          isChecked ? "[&>span]:bg-background" : "[&>span]:bg-white"
        )}
      />
    </div>
  );
};

export default Toggle;
